import request from '@/utils/request'

//立项查询
export async function lxcxLists(params) {
    return request({url: '/app/lxcx/lists', method: 'get', params})
}

